import React from 'react';
import { motion } from 'framer-motion';

const FeatureCard = ({ icon, title, description, color }) => {
  const colorClasses = {
    'from-blue-500 to-cyan-500': 'from-blue-500 to-cyan-500',
    'from-green-500 to-emerald-500': 'from-green-500 to-emerald-500',
    'from-purple-500 to-pink-500': 'from-purple-500 to-pink-500',
    'from-orange-500 to-red-500': 'from-orange-500 to-red-500',
    'from-indigo-500 to-blue-500': 'from-indigo-500 to-blue-500',
    'from-teal-500 to-green-500': 'from-teal-500 to-green-500'
  };

  return (
    <motion.div
      className="card p-8 text-center h-full flex flex-col items-center border border-gray-200 hover:border-primary-500 hover:shadow-lg hover:-translate-y-2"
      whileHover={{ y: -8 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
    >
      <div className={`w-20 h-20 rounded-2xl flex items-center justify-center mb-6 bg-gradient-to-r ${colorClasses[color]} shadow-lg`}>
        <div className="w-10 h-10 text-white">
          {icon}
        </div>
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-4 leading-tight">{title}</h3>
      <p className="text-gray-600 leading-relaxed flex-1">{description}</p>
    </motion.div>
  );
};

export default FeatureCard;
